import { getCities } from "../api/cities";
import { IOption } from "../utils";
import { useQuery } from "@tanstack/react-query";


export default function useGetCities(): undefined | IOption<string>[] {
  const {data: cities} = useQuery(
    {
      queryKey: ['cities'],
      queryFn:  async () => {
        return (await getCities()).map(c => ({
          label: c,
          value: c === "Все" ? '' : c
        }))
     }
    }
  )

  return cities
}